import { types } from 'mobx-state-tree';

export default types.model('AddressSuggestion', {
  description: '',
  place_id: types.string,
});
